import * as XLSX from 'xlsx';

export function normalizeUploadFilterValue(value: string): string {
  if (!value) {
    return '';
  }
  return value.toString().toLowerCase().replace(/\s/g, '');
}

export function dedupeAndSortByTemplateName<T extends { uploadtemplatename: string }>(items: T[]): T[] {
  const seen = new Set<string>();
  const unique: T[] = [];
  for (const item of items) {
    const name = item.uploadtemplatename;
    if (name && !seen.has(name)) {
      seen.add(name);
      unique.push(item);
    }
  }
  return unique.sort((a, b) => a.uploadtemplatename.localeCompare(b.uploadtemplatename));
}

export function parseExcelFileToBodyRows(file: File): Promise<any[][]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const bstr = e.target?.result as string;
        const workbook = XLSX.read(bstr, { type: 'binary' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', raw: false });
        const body = rows.slice(1);
        resolve(body.filter(row => row && row.some(cell => String(cell).trim() !== '')));
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsBinaryString(file);
  });
}

export function extractApiErrorMessage(errorResponse: { error?: { message?: string } }): string {
  return errorResponse?.error?.message || 'An unexpected error occurred';
}
